import { fetchCountProjectTypes } from './fetchCountProjectsByTypeThunk';
export default fetchCountProjectTypes;
